import { IonButton, IonCard, IonItem } from "@ionic/react"
import React from "react"
import FormArea from './area'
import FormName from './name'

export interface AdditionalBuilding {
  id: any
  name: string
  area: number
}

interface Props {
  building: AdditionalBuilding
  onDelete: () => void
  onChange: (person: AdditionalBuilding) => void
}

const AdditionalBuildingCard: React.FC<Props> = (props) => {
  const onChange = (data: Partial<AdditionalBuilding>) => {
    props.onChange({...props.building, ...data})
  }

  const onDelete = () => {
    props.onDelete()
  }

  return (
    <IonCard>
      <FormName value={props.building.name} onChange={value => onChange({name: value})}/>
      <FormArea value={props.building.area} onChange={value => onChange({area: value})}/>

      <IonItem>
        <IonButton fill="outline" onClick={onDelete} slot="end">Nebengebäude entfernen</IonButton>
      </IonItem>
    </IonCard>
  )
}

export default AdditionalBuildingCard
